import { useCurrentCompany, useFeatureFlag } from '@bonusly/who-am-i';

import { useUserContentDismissal } from '../profile/user-content-dismissal';
import { TRIAL_WELCOME_DISMISSAL } from '../recognition/trial-welcome';

/** sessionStorage key set when Welcome V2 signup completes (founding admin only). */
const SIGNUP_SESSION_KEY = 'bizy_onboarding_signup_session';

/** Mark this tab as the founding admin's signup session before homepage handoff. */
export const markTrialSignupSession = (): void => {
	try {
		sessionStorage.setItem(SIGNUP_SESSION_KEY, '1');
	} catch {
		// Private mode / quota — panel may auto-open as before.
	}
};

const isTrialSignupSession = (): boolean => {
	try {
		return sessionStorage.getItem(SIGNUP_SESSION_KEY) === '1';
	} catch {
		return false;
	}
};

/**
 * True while the founding admin's signup session still awaits `trial_welcome_sent`.
 * Keeps the Bizy panel from auto-opening over the welcome demo (Meet Bizy promo counterpart).
 */
export const useHasPendingTrialWelcomeDemo = (): boolean => {
	const isTrial = !!useCurrentCompany()?.isTrial;
	const isBizyLedOnboardingEnabled = useFeatureFlag('plg-bizy-led-onboarding');
	const isEligible = isTrial && isBizyLedOnboardingEnabled && isTrialSignupSession();
	const { loading, data } = useUserContentDismissal({ ...TRIAL_WELCOME_DISMISSAL, enabled: isEligible });

	if (!isEligible) return false;
	// Loading counts as pending so the panel can't open before we know dismissal state.
	if (loading) return true;
	return !data?.dismissed_at;
};
